document.addEventListener("DOMContentLoaded", function () {
  const productGrid = document.getElementById('product-grid');
  let nextElement = document.querySelector('.pagination__item--next');
  let nextUrl = nextElement ? nextElement.getAttribute('href') : null;
  let isLoading = false;
  
  if (!productGrid || !nextUrl) return;

  const sectionId = productGrid.getAttribute('data-id');

  // Create a loading spinner/text
  const loader = document.createElement('div');
  loader.style.textAlign = 'center';
  loader.style.padding = '20px';
  loader.style.opacity = '0';
  loader.style.transition = 'opacity 0.3s';
  loader.innerHTML = '<span>Loading more products...</span>';
  productGrid.parentNode.appendChild(loader);

  const loadMoreProducts = async () => {
    if (isLoading || !nextUrl) return;
    isLoading = true;
    loader.style.opacity = '1'; // Show loader

    try {
      const fetchUrl = `${nextUrl}&section_id=${sectionId}`;
      const response = await fetch(fetchUrl);
      const text = await response.text();
      const parser = new DOMParser();
      const newDocument = parser.parseFromString(text, 'text/html');

      const newProducts = newDocument.querySelectorAll('#product-grid .grid__item');
      
      newProducts.forEach(product => {
        productGrid.appendChild(product);
      });

      // Update next URL
      const newNextElement = newDocument.querySelector('.pagination__item--next');
      if (newNextElement) {
        nextUrl = newNextElement.getAttribute('href');
      } else {
        nextUrl = null;
        loader.style.display = 'none'; // Hide loader permanently when done
      }

    } catch (error) {
      console.error(error);
    } finally {
      isLoading = false;
      loader.style.opacity = '0'; // Hide loader after fetch
    }
  };

  window.addEventListener('scroll', () => {
    const { scrollTop, scrollHeight, clientHeight } = document.documentElement;
    if (scrollTop + clientHeight >= scrollHeight - 400) {
      loadMoreProducts();
    }
  });
});